import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '@victory-lib-ui/shared/utils';

/**
 * Error Interceptor
 * Handles HTTP errors globally and provides consistent error handling
 */
export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An error occurred';

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = `Client Error: ${error.error.message}`;
        logger.error('HTTP Client Error', error.error);
      } else {
        // Server-side error
        errorMessage = `Server Error: ${error.status} - ${error.message}`;
        logger.error('HTTP Server Error', {
          status: error.status,
          statusText: error.statusText,
          url: error.url,
          message: error.message,
        });

        // Handle specific error codes
        switch (error.status) {
          case 401:
            // Unauthorized - Could trigger logout or token refresh
            logger.warn('Unauthorized request - user may need to login');
            break;
          case 403:
            // Forbidden
            logger.warn('Forbidden request - insufficient permissions');
            break;
          case 404:
            // Not Found
            logger.warn('Resource not found');
            break;
          case 500:
            // Internal Server Error
            logger.error('Internal server error');
            break;
        }
      }

      return throwError(() => ({
        status: error.status,
        statusText: error.statusText,
        message: errorMessage,
        error: error.error,
      }));
    })
  );
};
